import StringMask from 'string-mask'

export function maskCpfCnpj(value) {
  const cleaned = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

  if (cleaned.length <= 11 && /^\d+$/.test(cleaned)) {
    return cleaned
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1-$2')
  }

  return cleaned
    .replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
    .replace(
      /^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9])/,
      '$1.$2.$3/$4'
    )
    .replace(
      /\/([A-Z0-9]{4})(\d{1,2})$/,
      '/$1-$2'
    )
}

export function maskCep(value) {
   const mask = new StringMask('00000-000')
   return mask.apply(value)
}

export function maskPhone(value) {
  const mask9Digits = new StringMask('(00) 00000-0000')
  const mask8Digits = new StringMask('(00) 0000-0000')

  return value.length === 11 ? mask9Digits.apply(value) : mask8Digits.apply(value)
}

export function maskByDocument(value) {
  const mapMask = {
    cpf: '###.###.###-##',
    cnpj: 'XX.XXX.XXX/XXXX-##'
  }

  return mapMask[value]
}
